import { sendForm } from "./forms/send-form";

export const InternalAPI = {
    forms: {
        sendForm,
    },
};